export function desktopListHeight(): string {
  return 'var(--desktop-list-height)';
}

export function mobileListHeight(): string {
  return 'var(--mobile-list-height)';
}

export function isMobile(): boolean {
  if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
    return true
  } else {
    return false
  }
}